<template>
  <y-block-box title="用户单位">
    <template #suffix>
      <router-link to="/recentUser">
        <i class="el-icon-right y-icon-btn"></i>
      </router-link>
    </template>
    <div class="word-cloud-container" v-loading="loading">
      <div ref="wordCloudChart" style="width: 100%; height: 100%;"></div>
    </div>
  </y-block-box>
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-wordcloud';

export default {
  name: 'WordCloudChart',
  props: {},
  data() {
    return {
      chart: null,
      loading:false,
    };
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    async initChart() {
      this.loading = true
      let res = await this.$callApi("board.getTeamCount");
      this.loading = false
      this.chart = echarts.init(this.$refs.wordCloudChart);
      const option = {
        tooltip: {},
        series: [{
          type: 'wordCloud',
          gridSize: 6, // 控制词云图的网格大小，值越大词语之间的间距越大
          sizeRange: [8, 24], // 控制词语的大小范围
          rotationRange: [0, 0], // 控制词语的旋转角度范围
          rotationStep: 45, // 控制词语旋转的步长
          shape: 'circle', // 控制词云图的形状，可选值为 'circle', 'cardioid', 'diamond', 'triangle-forward', 'triangle', 'pentagon', 'star'
          drawOutOfBound: false, // 控制词云图是否允许词语超出绘制区域
          layoutAnimation: true,// 布局的时候是否有动画
          // 图的位置
          left: 'center',
          top: 'center',
          width:'90%',
          height:'90%',
          textStyle: {
            fontFamily: 'sans-serif',
            // fontWeight: 'bold',
            color: function () {
              return 'rgb(' + [
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160),
                Math.round(Math.random() * 160)
              ].join(',') + ')';
            }
          },
          data: res.data,
          emphasis: {
            focus: 'self',
          }
        }],
      }
      this.chart.setOption(option);
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.word-cloud-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/common/WordCloudChart/WordCloudChart.vue